/**
 * Component Registry for Echo Biltmore
 * 
 * Inherits from @vibesites-apartment-management-consultants/theme-theme-homestead-milburn and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-apartment-management-consultants/theme-theme-homestead-milburn/registry';
import { Header } from './components/Header';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
